import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy
} from "@angular/router";
import { activatedRouteSnapshotGetPathFromRoot } from "src/app/support/activated-route";
import { DetachedRouteHandleService } from "src/app/services/detached-route-handle.service";

const log = (...args: any[]) => {};

@Injectable()
export class AppRouterReuseStrategy implements RouteReuseStrategy {
  private readonly detachedRouteHandleService = inject(
    DetachedRouteHandleService
  );

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    const futureKey = getRouteKey(future);
    const currKey = getRouteKey(curr);

    const ret =
      future.routeConfig === curr.routeConfig && futureKey === currKey;

    if (!ret) {
      const isTabCurr = !curr.firstChild;
      const isTabConfigCurr = !!curr.data?.tab;
      const pathFromRootCURR = activatedRouteSnapshotGetPathFromRoot(curr);
      const isTabFuture = !future.firstChild;
      const isTabConfigFuture = !!future.data?.tab;
      const pathFromRootFuture = activatedRouteSnapshotGetPathFromRoot(future);
      log(
        `shouldReuse -> isTabCurr: ${isTabCurr} - tabConfig: ${isTabConfigCurr} - pathFromRootCurrr: ${pathFromRootCURR}`
      );
      log(
        `shouldReuse -> isTabFuture: ${isTabFuture} - tabConfig: ${isTabConfigFuture} - pathFromRootFuture: ${pathFromRootFuture}`
      );
    }

    log(`shouldReuse -> ${ret}`);

    return ret;
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const isTab = !route.firstChild;
    const key = getRouteKey(route);
    let ret = isTab;

    if (ret) {
      if (this.detachedRouteHandleService.isReleased(key)) {
        this.detachedRouteHandleService.deleteReleeased(key);
        this.detachedRouteHandleService.delete(key);
        ret = false;
      }
    }

    log(`shouldDetach -> ${ret ? "YES" : "NO"} isTab: ${isTab} - key: ${key}`);

    return ret;
  }

  store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle | null
  ): void {
    if (handle) {
      const key = getRouteKey(route);

      log(`store ${key}`);

      this.detachedRouteHandleService.store(key, handle);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = getRouteKey(route);
    const ret =
      !route.firstChild &&
      !!route.data?.tab &&
      this.detachedRouteHandleService.has(key);
    log(` shouldAttach - ${key} - ${ret ? "YES" : "NO"}`);
    return ret;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = getRouteKey(route);

    if (!this.detachedRouteHandleService.has(key)) {
      log(`retrieve ${key} not found`);
      return null;
    }

    return this.detachedRouteHandleService.get(key) || null;
  }
}

function getRouteKey(snapshot: ActivatedRouteSnapshot): string {
  return activatedRouteSnapshotGetPathFromRoot(snapshot);
}
